<template>
  <div class="push-rule-bd tb" v-if="funcView.application_list">
    <div class="search-hd">
      <el-form :inline="true">
        <el-form-item>
          <el-button type="primary" icon="el-icon-plus" @click="addApplication" v-if="funcView.application_add">{{ funcView.application_add }}</el-button>
        </el-form-item>
        <el-form-item style="float: right; margin-right: 0">
          <custom-column ref="column"></custom-column>
        </el-form-item>
        <el-form-item style="float: right">
          <search-input :placeholder="$t('base_application.yymcyydm')" v-model="formSearch.search" @fetch="onPageChange({ page: 1 })"></search-input>
        </el-form-item>
        <el-form-item style="float: right">
          <custom-select
            v-model="formSearch.parentId"
            :filterable="true"
            url="basicApplicationPlatformList"
            :props="{ label: 'appName', value: 'appId' }"
            @change="onPageChange({ page: 1 })"
            :placeholder="$t('base_application.suo_shu_ping_tai')"
          ></custom-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="table-bd">
      <custom-table tableCode="applicationManage" :data="tableList" @filter="filterChange" @sort="sortChange" @column="setColumn" height="100%">
        <el-table-column :label="$t('Common.com_handle')" min-width="150px" fixed="right">
          <template slot-scope="scope">
            <el-button type="text" size="mini" @click="editApplication(scope.row)" v-if="funcView.application_edit">{{ funcView.application_edit }}</el-button>
            <el-button type="text" size="mini" @click="deleteApplication(scope.row)" v-if="funcView.application_delete">{{ funcView.application_delete }}</el-button>
          </template>
        </el-table-column>
      </custom-table>
    </div>
    <div class="table-page">
      <custom-page :total="totalRows" :page="formSearch.pageNum" :size="formSearch.pageSize" @change="onPageChange"></custom-page>
    </div>
    <application-item-dialog v-if="dialogVisible" :model="dialogModel" @close="dialogVisible = false" @success="onPageChange({ page: 1 })"></application-item-dialog>
  </div>
</template>

<script>
import apis from '@/utils/apis';
import applicationItemDialog from './children/application_item_dialog.vue';

export default {
  name: 'application',
  components: { applicationItemDialog },
  data() {
    return {
      formSearch: {
        pageNum: 1,
        pageSize: 50,
        search: '',
        parentId: ''
      },
      // 参数
      dialogVisible: false,
      dialogModel: {},
      tableList: [],
      totalRows: 0
    };
  },
  mounted: function () {
    this.getApplication();
    this.getFuncView();
  },
  methods: {
    // 获取消息规则列表
    getApplication: function () {
      this.$getJSON(apis.basicApplicationPage, this.formSearch).then((res) => {
        this.tableList = res.data.list;
        this.totalRows = res.data.total;
      });
    },
    // 分页变更
    onPageChange: function ({ page, size }) {
      this.formSearch.pageNum = page;
      this.formSearch.pageSize = size || this.formSearch.pageSize;
      this.getApplication();
    },
    // 新增规则
    addApplication: function () {
      this.dialogModel.type = 'add';
      this.dialogModel.title = this.$t('base_application.xin_zeng_ying_yong');
      this.dialogVisible = true;
    },
    // 编辑规则
    editApplication: function (data) {
      this.dialogModel.type = 'edit';
      this.dialogModel.title = this.$t('base_application.bian_ji_ying_yong');
      this.dialogModel.data = data;
      this.dialogVisible = true;
    },
    // 删除规则
    deleteApplication: function (data) {
      this.$showConfirm(this.$t('base_application.nqdyscxzdyym'))
        .then(() => {
          this.$postJSON(`${apis.basicApplicationDelete}/${data.appId}`).then(() => {
            this.getApplication();
          });
        })
        .catch(() => {});
    }
  }
};
</script>

<style lang="scss"></style>
